var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11H13C13.663 11 14.2989 10.7366 14.7678 10.2678C15.2366 9.79893 15.5 9.16304 15.5 8.5C15.5 7.83696 15.2366 7.20107 14.7678 6.73223C14.2989 6.26339 13.663 6 13 6H8.5V11ZM18.5 15.5C18.5 16.0909 18.3836 16.6761 18.1575 17.2221C17.9313 17.768 17.5998 18.2641 17.182 18.682C16.7641 19.0998 16.268 19.4313 15.7221 19.6575C15.1761 19.8836 14.5909 20 14 20H7.15C6.79102 20 6.5 19.709 6.5 19.35V4.65C6.5 4.29101 6.79101 4 7.15 4H13C13.881 4.00004 14.7425 4.25865 15.4779 4.74378C16.2132 5.2289 16.79 5.9192 17.1367 6.72907C17.4834 7.53894 17.5847 8.43276 17.4282 9.29969C17.2716 10.1666 16.8641 10.9685 16.256 11.606C16.9386 12.0013 17.5053 12.5692 17.8992 13.2526C18.2931 13.9361 18.5003 14.7112 18.5 15.5ZM8.5 13V18H14C14.663 18 15.2989 17.7366 15.7678 17.2678C16.2366 16.7989 16.5 16.163 16.5 15.5C16.5 14.837 16.2366 14.2011 15.7678 13.7322C15.2989 13.2634 14.663 13 14 13H8.5Z",
    fill: "#52525B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.c4be97669be570053496e6cf28d6efae.svg";
export { ForwardRef as ReactComponent };